import React, { Component } from 'react';
import { createStore } from 'redux';
import ContentViewer from './../content-viewer/ContentViewer';
import Header from './../header/Header'
import Footer from './../footer/Footer'
import reducer from './../../pages/reducer'
import { Provider } from 'react-redux';
import './../../css/App.css';
import './../SiteCat/SiteCat';

const store = createStore(reducer);
class App extends Component {

  render() {
    return (
      <Provider store={store}>
        <div className="app-wrapper">
          <React.Fragment>
            <Header />
            <div className="content">
              <ContentViewer />
            </div>
          </React.Fragment>
          <Footer />
        </div>
      </Provider>
    );
  }
}

export default App;
